module.exports = __webpack_public_path__ + "img/build.c36ea71c.png";